import { DEFAULT_API_ENDPOINT, MESSAGE_KEY_ORIGIN, URL_PARAMETER_RECIPIENT_ORIGIN, URL_PARAMETER_SITE_UUID } from "../../core/const/Constant";
import Logger from "../../core/utils/Logger";
import { subscribeMessage } from "../services/WindowMessage";
import Utils from "../utils/Common.util";
import { getToken } from "./token.api";


let _origin = Utils.QueryUrlParameter(URL_PARAMETER_RECIPIENT_ORIGIN);
const unSubOrigin = subscribeMessage(MESSAGE_KEY_ORIGIN, data => {
    _origin = encodeURIComponent(data);
    unSubOrigin();
});

export const API_ENDPOINT = Utils.QueryUrlParameter('endpoint') || DEFAULT_API_ENDPOINT;

const SITE_UUID = Utils.QueryUrlParameter(URL_PARAMETER_SITE_UUID)
let API_TOKEN = '';


export const apiCaching = (() => {
    const caching = new Map();
    return {
        set: (key, data) => caching.set(key, data),
        get: key => caching.get(key),
        setIfNotExist: (key, data) => {
            if (!caching.has(key)) {
                caching.set(key, data);
            }
        },
        delete: key => caching.delete(key),
        has: key => caching.has(key)

    }
})();

export const needForwardToIFrame = () => !Utils.IsIFrame();

/**
 * 
 * @param {Response} response 
 */
const doCheckStatus = (() => {
    const responseStatus = {
        '500': (jsonResult) => { throw new Error(`Internal Error`) },
        '404': (jsonResult) => { throw new Error(`404 Not found`) },
        '400': (jsonResult) => { throw jsonResult },
        '200': (jsonResult) => { }
    }

    return (statusCode, jsonResult) => {
        if (typeof responseStatus[statusCode] === 'function') {
            responseStatus[statusCode](jsonResult);
        }
    }
})();

const _defaultHeaderOption = {
    includeAuth: true,
    includeJsonContentType: true
}

const buildHeader = async ({ includeAuth, includeJsonContentType } = _defaultHeaderOption) => {
    const headers = {}
    if (includeJsonContentType) {
        headers["Content-Type"] = "application/json";
    }
    if (includeAuth) {
        const response = await getToken(SITE_UUID);
        if (response && response.status) {
            headers['Authorization'] = response.data.token
        }
    }
    return headers;
}

export const GET = async (url, headerOptions) => {
    const headers = await buildHeader(headerOptions);
    const response = await fetch(url, {
        method: "GET",
        headers
    });
    const json = await response.json();
    try {
        doCheckStatus(response.status, json);
    } catch (err) {
        Logger.error('[ApiService - GET]', err);
    }
    return json;
}

export const POST = async (url, payload, headerOptions) => {
    const headers = await buildHeader(headerOptions);
    const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        headers,
        redirect: "follow",
        referrerPolicy: "no-referrer",
        body: payload
    });
    const json = await response.json();
    try {
        doCheckStatus(response.status, json);
    } catch (err) {
        Logger.unsuccess('[ApiService - POST]', err);
        // throw err;
    }
    return json;
}

export const UPLOAD = async (url, payload, headerOptions) => {
    const headers = await buildHeader({ ...headerOptions, includeJsonContentType: false });
    const response = await fetch(url, {
        method: "POST",
        headers,
        body: payload
    });
    const json = await response.json();
    try {
        doCheckStatus(response.status, json);
    } catch (err) {
        Logger.unsuccess('[ApiService - POST]', err);
        // throw err;
    }
    return json;
}

